module.exports = __webpack_public_path__ + "static/img/wz_gg.c75ef20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/wz_gg.png
// module id = bw6P
// module chunks = 2